module.exports = __webpack_public_path__ + "assets/veritas_logo.a1851a9e.png";